import * as React from 'react'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepContent from '@mui/material/StepContent'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import PropTypes from 'prop-types'

const QuestStepper = ({ activeStepNumber, quests }) => {
  return (
    <Box sx={{ p: 3, pr: 4, overflow: 'auto' }}>
      <Stepper activeStep={activeStepNumber} orientation="vertical">
        {quests.map((quest, index) => (
          <Step key={quest.turn}>
            <StepLabel icon={
                <Chip sx={ (activeStepNumber === quest.turn) ? { bgcolor: '#459EB9', opacity: 0.8 } : null } label={quest.turn} ></Chip>
            } >
              {quest.theme}
            </StepLabel>
            <StepContent>
              <Typography>{quest.task}</Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

QuestStepper.propTypes = {
  activeStepNumber: PropTypes.number.isRequired,
  quests: PropTypes.array
}

export default QuestStepper
